(() => {
  const body = document.body;
  const panel = document.querySelector('[data-mobile-panel]');
  const open = document.querySelector('[data-mobile-open]');
  const close = document.querySelector('[data-mobile-close]');

  const setMenu = (isOpen) => {
    if (!panel) return;
    panel.classList.toggle('is-open', isOpen);
    panel.setAttribute('aria-hidden', String(!isOpen));
    body.classList.toggle('nav-open', isOpen);
    if (open) open.setAttribute('aria-expanded', String(isOpen));
  };

  open?.addEventListener('click', () => setMenu(true));
  close?.addEventListener('click', () => setMenu(false));
  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') setMenu(false);
  });

  document.querySelectorAll('[data-sort-by]').forEach((select) => {
    select.addEventListener('change', () => {
      const url = new URL(window.location.href);
      url.searchParams.set('sort_by', select.value);
      window.location.assign(url.toString());
    });
  });

  // Collection cards stay in the exact order supplied by Shopify.
  // Shopify's collection sorting setting and customer sort selections
  // now control their position without any theme-side reshuffling.

  const updateGalleryDots = (shell, activeItem) => {
    if (!shell || !activeItem) return;
    shell.querySelectorAll('[data-gallery-dot]').forEach((dot) => {
      const isActive = dot.dataset.mediaId === activeItem.dataset.mediaId;
      dot.classList.toggle('is-active', isActive);
      dot.setAttribute('aria-current', isActive ? 'true' : 'false');
      dot.setAttribute('aria-pressed', isActive ? 'true' : 'false');
    });
  };

  // Mobile Safari can snap the full-image scroller to the wrong card even
  // after the thumbnail has been highlighted. Mobile now has one explicit
  // visible image; the thumbnail border and image change in the same action.
  const isMobileGallery = () => window.matchMedia('(max-width: 999px)').matches;
  const showProductMedia = (shell, item) => {
    if (!shell || !item) return;
    const gallery = shell.querySelector('[data-product-gallery]');
    if (!gallery) return;
    gallery.querySelectorAll('[data-product-media]').forEach((media) => {
      media.classList.toggle('is-mobile-active', media === item);
    });
    if (isMobileGallery()) gallery.scrollLeft = 0;
    updateGalleryDots(shell, item);
  };

  document.querySelectorAll('[data-product-gallery-shell]').forEach((shell) => {
    const gallery = shell.querySelector('[data-product-gallery]');
    if (!gallery) return;
    const items = () => [...gallery.querySelectorAll('[data-product-media]')];
    const nearestItem = () => {
      if (isMobileGallery()) {
        return gallery.querySelector('[data-product-media].is-mobile-active')
          || gallery.querySelector('[data-product-media].is-lead')
          || items()[0] || null;
      }
      const galleryLeft = gallery.getBoundingClientRect().left;
      return items().reduce((best, item) =>
        !best || Math.abs(item.getBoundingClientRect().left - galleryLeft) <
        Math.abs(best.getBoundingClientRect().left - galleryLeft) ? item : best, null);
    };

    shell.querySelectorAll('[data-gallery-dot]').forEach((dot) => {
      dot.setAttribute('aria-pressed', String(dot.classList.contains('is-active')));
      dot.addEventListener('click', () => {
        const item = items().find((media) => media.dataset.mediaId === dot.dataset.mediaId);
        showProductMedia(shell, item);
      });
    });

    shell.querySelector('[data-gallery-previous]')?.addEventListener('click', () => {
      const list = items();
      const index = list.indexOf(nearestItem());
      showProductMedia(shell, list[Math.max(0, index - 1)]);
    });

    shell.querySelector('[data-gallery-next]')?.addEventListener('click', () => {
      const list = items();
      const index = list.indexOf(nearestItem());
      showProductMedia(shell, list[Math.min(list.length - 1, index + 1)]);
    });

    // Keep native-feeling left/right swipes without relying on scroll snapping.
    // Allow vertical page scrolling and do not intercept the zoom button.
    let touchStart = null;
    gallery.addEventListener('touchstart', (event) => {
      if (!isMobileGallery() || event.touches.length !== 1
        || event.target.closest('[data-gallery-zoom]')) {
        touchStart = null;
        return;
      }
      touchStart = { x: event.touches[0].clientX, y: event.touches[0].clientY };
    }, { passive: true });
    gallery.addEventListener('touchend', (event) => {
      if (!touchStart || !isMobileGallery() || !event.changedTouches.length) return;
      const deltaX = event.changedTouches[0].clientX - touchStart.x;
      const deltaY = event.changedTouches[0].clientY - touchStart.y;
      touchStart = null;
      if (Math.abs(deltaX) < 40 || Math.abs(deltaX) <= Math.abs(deltaY) * 1.2) return;
      const list = items();
      const index = list.indexOf(nearestItem());
      const next = Math.max(0, Math.min(list.length - 1, index + (deltaX < 0 ? 1 : -1)));
      showProductMedia(shell, list[next]);
    }, { passive: true });

    // Normalize the initial state for images and thumbnail borders.
    showProductMedia(shell, gallery.querySelector('[data-product-media].is-mobile-active')
      || gallery.querySelector('[data-product-media].is-lead') || items()[0]);
  });

  document.querySelectorAll('[data-product-select]').forEach((select) => {
    select.addEventListener('change', () => {
      const option = select.options[select.selectedIndex];
      const form = select.closest('form');
      const idInput = form?.querySelector('input[name="id"]');
      const addButton = form?.querySelector('[data-add-to-bag]');
      const addLabel = form?.querySelector('[data-add-label]');
      const price = document.querySelector('[data-product-price] .price');
      const available = option.dataset.available === 'true';
      const picker = form?.querySelector('[data-variant-picker][data-requires-size]');
      const sizeChosen = !picker || picker.dataset.sizeChosen === 'true';
      if (idInput) idInput.value = option.value;
      if (addButton) addButton.disabled = !available || !sizeChosen;
      if (addLabel) addLabel.textContent = !available ? 'Sold out' : !sizeChosen ? 'Choose a size' : `Add to bag — ${option.dataset.price}`;
      const confirmation = form?.querySelector('[data-add-feedback]');
      if (confirmation) confirmation.hidden = true;
      if (price) {
        price.replaceChildren();
        if (option.dataset.comparePrice) {
          const compare = document.createElement('s');
          compare.textContent = option.dataset.comparePrice;
          const sale = document.createElement('span');
          sale.className = 'price__sale';
          sale.textContent = option.dataset.price;
          price.append(compare, sale);
        } else {
          const regular = document.createElement('span');
          regular.textContent = option.dataset.price;
          price.append(regular);
        }
      }

      const productPage = select.closest('.product-page') || document;
      const gallery = productPage.querySelector('[data-product-gallery]');
      const shell = gallery?.closest('[data-product-gallery-shell]');
      let media = option.dataset.mediaId ? gallery?.querySelector(`[data-media-id="${option.dataset.mediaId}"]`) : null;

      // Some fulfillment apps provide a variant image URL without a featured-media ID.
      // Match that URL back to its gallery item before falling back to the lead image.
      if (!media && option.dataset.imageSrc && gallery) {
        const variantPath = new URL(option.dataset.imageSrc, window.location.origin).pathname;
        media = [...gallery.querySelectorAll('[data-product-media]')].find((item) => {
          const itemImage = item.querySelector('img');
          if (!itemImage) return false;
          return new URL(itemImage.currentSrc || itemImage.src, window.location.origin).pathname === variantPath;
        }) || null;
      }

      if (gallery && media) {
        if (window.matchMedia('(max-width: 999px)').matches) {
          // Avoid DOM reordering here: mobile Safari can retain the old scroll position.
          showProductMedia(shell, media);
        } else {
          gallery.querySelector('.is-lead')?.classList.remove('is-lead');
          media.classList.add('is-lead');
          gallery.prepend(media);
          showProductMedia(shell, media);
        }
        updateGalleryDots(shell, media);
      } else if (gallery && option.dataset.imageSrc) {
        // Last-resort support for imported variants whose image is not in product.media.
        const lead = gallery.querySelector('.is-lead') || gallery.querySelector('[data-product-media]');
        const leadImage = lead?.querySelector('img');
        if (leadImage) {
          leadImage.src = option.dataset.imageSrc;
          leadImage.srcset = '';
          leadImage.alt = option.dataset.variantTitle || leadImage.alt;
          const zoomButton = lead.querySelector('[data-gallery-zoom]');
          if (zoomButton) zoomButton.dataset.zoomSrc = option.dataset.imageSrc;
          if (window.matchMedia('(max-width: 999px)').matches) showProductMedia(shell, lead);
          updateGalleryDots(shell, lead);
        }
      }

      const url = new URL(window.location.href);
      url.searchParams.set('variant', option.value);
      window.history.replaceState({}, '', url.toString());
    });
  });

  // Keep shoppers on the product page after adding an item. Show an inline
  // confirmation and update the bag count; no cart-page redirect.
  document.querySelectorAll('.product-page form.product-form').forEach((form) => {
    const button = form.querySelector('[data-add-to-bag]');
    const label = form.querySelector('[data-add-label]');
    const feedback = form.querySelector('[data-add-feedback]');
    const feedbackText = form.querySelector('[data-add-feedback-text]');
    const feedbackLink = form.querySelector('[data-add-feedback-link]');
    const picker = form.querySelector('[data-variant-picker][data-requires-size]');
    const select = form.querySelector('[data-product-select]');
    if (!button || !feedback || !feedbackText) return;

    const showFeedback = (message, isError = false) => {
      feedback.hidden = false;
      feedback.classList.toggle('is-error', isError);
      feedbackText.textContent = message;
      if (feedbackLink) feedbackLink.hidden = isError;
    };

    form.addEventListener('submit', async (event) => {
      event.preventDefault();
      if (form.dataset.adding === 'true') return;
      if (picker && picker.dataset.sizeChosen !== 'true') {
        showFeedback('Please choose a size first.', true);
        picker.querySelector('[data-size-option]')?.scrollIntoView({ block: 'center', behavior: 'smooth' });
        picker.querySelector('[data-size-option] button:not(:disabled)')?.focus({ preventScroll: true });
        return;
      }
      const formData = new FormData(form);
      if (!formData.get('id')) {
        showFeedback('Please choose an available option.', true);
        return;
      }
      feedback.hidden = true;
      form.dataset.adding = 'true';
      button.disabled = true;
      if (label) label.textContent = 'Adding to bag…';
      const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      try {
        const response = await fetch(root + 'cart/add.js', {
          method: 'POST',
          body: formData,
          credentials: 'same-origin',
          headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' }
        });
        if (!response.ok) {
          const payload = await response.json().catch(() => ({}));
          throw new Error(payload.description || payload.message || 'Could not add this item. Please try again.');
        }
        showFeedback('✓ Added to bag.');
        try {
          const cartResponse = await fetch(root + 'cart.js', { credentials: 'same-origin', cache: 'no-store' });
          if (cartResponse.ok) {
            const cart = await cartResponse.json();
            document.querySelectorAll('.header__actions a[aria-label^="Cart"]').forEach((bag) => {
              bag.setAttribute('aria-label', `Cart with ${cart.item_count} items`);
              let count = bag.querySelector('.cart-count');
              if (cart.item_count > 0) {
                if (!count) {
                  count = document.createElement('span');
                  count.className = 'cart-count';
                  bag.appendChild(count);
                }
                count.textContent = String(cart.item_count);
              } else if (count) {
                count.remove();
              }
            });
          }
        } catch (cartError) {
          // The add succeeded; a badge-refresh failure must never turn it into an error.
        }
      } catch (error) {
        showFeedback(error.message || 'Could not add this item. Please try again.', true);
      } finally {
        form.dataset.adding = 'false';
        const option = select?.options[select.selectedIndex];
        const available = !option || option.dataset.available === 'true';
        const sizeChosen = !picker || picker.dataset.sizeChosen === 'true';
        button.disabled = !available || !sizeChosen;
        if (label) {
          label.textContent = !available ? 'Sold out'
            : !sizeChosen ? 'Choose a size'
            : `Add to bag — ${option?.dataset.price || ''}`.trim();
        }
      }
    });
  });

  const lightbox = document.querySelector('[data-product-lightbox]');
  if (lightbox) {
    const image = lightbox.querySelector('[data-lightbox-image]');
    let activeZoomButton = null;

    const zoomButtons = () => [...document.querySelectorAll('[data-gallery-zoom]')];
    const openLightbox = (button) => {
      activeZoomButton = button;
      image.src = button.dataset.zoomSrc;
      image.alt = button.getAttribute('aria-label')?.replace(/^Zoom\s*/, '') || 'Product image';
      lightbox.hidden = false;
      document.body.classList.add('lightbox-open');
      lightbox.querySelector('[data-lightbox-close]')?.focus();
    };
    const closeLightbox = () => {
      lightbox.hidden = true;
      document.body.classList.remove('lightbox-open');
      activeZoomButton?.focus();
    };
    const moveLightbox = (direction) => {
      const buttons = zoomButtons();
      const index = buttons.indexOf(activeZoomButton);
      activeZoomButton = buttons[(index + direction + buttons.length) % buttons.length];
      image.src = activeZoomButton.dataset.zoomSrc;
      image.alt = activeZoomButton.getAttribute('aria-label')?.replace(/^Zoom\s*/, '') || 'Product image';
    };

    zoomButtons().forEach((button) => button.addEventListener('click', () => openLightbox(button)));
    lightbox.querySelector('[data-lightbox-close]')?.addEventListener('click', closeLightbox);
    lightbox.querySelector('[data-lightbox-previous]')?.addEventListener('click', () => moveLightbox(-1));
    lightbox.querySelector('[data-lightbox-next]')?.addEventListener('click', () => moveLightbox(1));
    lightbox.addEventListener('click', (event) => { if (event.target === lightbox) closeLightbox(); });
    document.addEventListener('keydown', (event) => {
      if (lightbox.hidden) return;
      if (event.key === 'Escape') closeLightbox();
      if (event.key === 'ArrowLeft') moveLightbox(-1);
      if (event.key === 'ArrowRight') moveLightbox(1);
    });
  }
  // Label only Kaching price-only buttons. Keep app-controlled price and click behavior intact.
  const tagHatPage = document.querySelector('[data-tag-hat-product]');
  if (tagHatPage) {
    const priceOnlyLabel = /^(?:[$€£]\s*\d[\d,]*(?:\.\d{1,2})?|\d[\d,]*(?:\.\d{1,2})?\s*(?:USD|CAD))$/i;
    let scheduled = false;
    const labelHatPriceButtons = () => {
      scheduled = false;
      tagHatPage.querySelectorAll('button').forEach((button) => {
        const text = (button.textContent || '').replace(/\s+/g, ' ').trim();
        const priceOnly = priceOnlyLabel.test(text);
        button.classList.toggle('tag-hat-price-only-button', priceOnly);
        if (priceOnly) button.setAttribute('aria-label', 'Add to bag');
      });
    };
    const scheduleHatButtonUpdate = () => {
      if (scheduled) return;
      scheduled = true;
      requestAnimationFrame(labelHatPriceButtons);
    };
    new MutationObserver(scheduleHatButtonUpdate).observe(tagHatPage, { childList: true, characterData: true, subtree: true });
    labelHatPriceButtons();
  }
})();
